<template>
  <div class="combined-dialog" v-if="isShow">
    <div class="combined-main">
      <!--    客户留言-->
      <div class="dialog-cn remark" v-if="isType === 'remark'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="remark-cn dialog-v" v-if="submitType !== '投诉'">
          <span class="mr-10">{{ submitType }}:</span>
          <el-input v-model="remarkMes.message" clearable></el-input>
        </div>
        <div class="remark-cn dialog-v" v-if="submitType === '投诉'">
          <el-input v-model="remarkMes.message" type="textarea" clearable></el-input>
        </div>
        <div class="dialog-btn">
          <el-button @click="changeRemarkDialog" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    投诉-->
      <div class="dialog-cn complain-cn" v-if="isType === 'complain'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class=" dialog-v">
          <div class="complain-ipt" style="margin-top: 10px;">
            <span>平台号:</span>
            <p>{{ remarkMes.message }}</p>
          </div>
          <div class="complain-ipt">
            <span>业务:</span>
            <p>{{ remarkMes.labelTitle }}</p>
          </div>
          <div class="complain-ipt">
            <span>投诉内容:</span>
            <el-input v-model="category" type="textarea" ref="cmRef" clearable></el-input>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="onComplain" round type="primary">处理</el-button>
        </div>
      </div>
      <!--    修改分类名称-->
      <div class="dialog-cn change-category-name" v-if="isType === 'changeCategoryName'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="change-category-ipt dialog-v"> {{ remarkMes.labelTitle }}: <el-input v-model="remarkMes.message.fullName" clearable></el-input>
        </div>
        <div class="dialog-btn">
          <el-button @click="changeRemarkDialog" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    更改授信额度-->
      <div class="dialog-cn change-category-name" v-if="isType === 'changeBalanceEq'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="change-category-ipt dialog-v"> {{ remarkMes.labelTitle }}: <el-input clearable v-model="remarkMes.message" type="number" :min="0" @mousewheel.native.prevent></el-input>
        </div>
        <div class="dialog-btn">
          <el-button @click="changeRemarkDialog" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    充值-->
      <div class="dialog-cn remark recharge" v-if="isType === 'recharge'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>充值金额：{{ title }}</p>
        <div class="recharge-img dialog-v">
          <div>
            <img src="@/assets/images/money.svg" alt="">
            <span>支付宝</span>
          </div>
          <div>
            <img src="@/assets/images/money.svg" alt="">
            <span>微信</span>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="changeRemarkDialog" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    在线充值-->
      <div class="dialog-cn " v-if="isType === 'rechargeOnline'">
        <!-- <i class="el-icon-circle-close" @click="hide"></i> -->
        <!-- <i class="el-icon-close" @click="hide"></i> -->
        <div class="recharge-online">
          <p style="height: 50px;line-height: 50px;">充值金额：￥{{ this.rechargeInfo.amount }}</p>
          <div class="recharge-img">
            <div>
              <img :src="this.rechargeInfo.qrcode" alt="">
              <span>使用微信或支付宝扫码支付</span>
            </div>
          </div>
          <el-button type="primary" @click="submitType = '在线充值', changeRemarkDialog()" round>我已充值</el-button>
          <!-- <button type="button" @click="changeRemarkDialog('充值')">确定</button> -->
        </div>
      </div>
      <!--    删除-->
      <div class="dialog-cn" v-if="isType === 'delete' || this.technologyList === 'deleteAdmin'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 v-html="deleteMes.message" class=" dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="deleteItem" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    取消订单-->
      <div class="dialog-cn" v-if="isType === 'cancel'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 v-html="content" class="dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="cancelOrder" round type="primary">确定</el-button>
        </div>
      </div>
      <!--  申请余额支付  -->
      <div class="dialog-cn" v-if="isType === 'balanceapply'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 ref="balanceapplyRef" v-if="submitType === 'balanceapply'" class="dialog-v"> 申请余额支付：{{ content }}<br> 是否确定申请余额支付？ </h3>
        <h3 v-html="content" v-if="submitType !== 'balanceapply'" class="dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="balancePay" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    复制信息-->
      <div class="dialog-cn" v-if="isType === 'copy'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-v">
          <h3 style="padding-bottom: 0">添加成员成功，已将账号信息以短信形式发送</h3>
          <h3 style="padding-top: 0" v-html="customerMes.message" id="foo"></h3>
        </div>
        <div class="dialog-btn">
          <el-button @click="copyMes()" data-clipboard-target="#foo" class="btn" round type="primary">复制信息</el-button>
        </div>
      </div>
      <!--   订单状态  -->
      <div class="dialog-cn dialog-status" v-if="isType === 'status'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-content dialog-v">
          <el-table :data="content" border :empty-text="'暂无数据'">
            <el-table-column property="date" label="状态" min-width="100"></el-table-column>
            <el-table-column property="remark" label="备注" min-width="100" v-if="submitType === 'checkLog'"></el-table-column>
            <el-table-column property="name" label="更新时间" min-width="100"></el-table-column>
            <el-table-column property="address" label="操作人" min-width="100"></el-table-column>
          </el-table>
        </div>
        <div class="dialog-btn">
          <el-button @click="hide" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    添加成员-->
      <div class="dialog-cn" v-if="isType === 'addMember'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-content dialog-v">
          <el-form ref="addMenberform" :model="memberForm" label-width="80px" :rules="rules">
            <el-form-item label="姓名:" prop="name">
              <el-input v-model="memberForm.name" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号:" prop="phone">
              <el-input v-model="memberForm.phone" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-btn">
          <el-button @click="addMember" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    快递追踪-->
      <div class="dialog-cn express-cn" v-if="isType === 'express'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="express-block dialog-v">
          <div class="express-com">
            <h3>快递公司:</h3> 中通快递
          </div>
          <div class="express-com">
            <h3>物流单号:</h3> 128745988852147
          </div>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size"
              :timestamp="activity.timestamp" status="wait"> {{ activity.content }} </el-timeline-item>
          </el-timeline>
        </div>
        <div class="dialog-btn">
          <el-button round type="primary" @click="hide">确定</el-button>
        </div>
      </div>
      <!--    平台审核拒绝-->
      <div class="dialog-cn checkfalse-cn" v-if="isType === 'checkfalse'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 v-html="content" class="dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="checkfalsePlatform" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    平台审核通过-->
      <div class="dialog-cn checkfalse-cn" v-if="isType === 'checktrue'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 v-html="content" class="dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="checktruePlatform" round type="primary">确定</el-button>
        </div>
      </div>
      <div class="dialog-cn" v-if="isType === 'changeSalesman'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 v-html="content" class="dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="confirmOK" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    添加SKU-->
      <div class="dialog-cn addSKU-cn" v-if="isType === 'addSKU'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-v">
          <el-form :model="addSKU" label-width="150px" ref="addSKURef" :rules="addSKURule">
            <el-form-item label="合成尺寸:" prop="size">
              <el-table :data="technologyList" border style="width: 300px;text-align: center">
                <el-table-column label="合成尺寸类型" prop="composeName"></el-table-column>
                <el-table-column label="数量" prop="pageNum">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.pageNum" style="width: 80px;margin: 0" v-if="scope.row.composeSizeType.allowAddPage === 1" clearable></el-input>
                    <span v-if="scope.row.composeSizeType.allowAddPage === 0">1</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label="基础P数:" prop="basePage">
              <span v-if="allowPage">{{ basePage }}</span>
              <el-input v-if="!allowPage" v-model="basePage" oninput="value = value.replace(/[^\d]/g,'')" clearable></el-input>
            </el-form-item>
            <el-form-item label="最大P数:" prop="maxPage">
              <el-input v-model="addSKU.maxPage" oninput="value = value.replace(/[^\d]/g,'')" clearable></el-input>
            </el-form-item>
            <el-form-item label="一次增加P数:" prop="stepLength">
              <el-input v-model="addSKU.stepLength" oninput="value = value.replace(/[^\d]/g,'')" clearable></el-input>
            </el-form-item>
            <el-form-item label="基础P数平台价格:" prop="minPlatformPrice">
              <el-input v-model="addSKU.minPlatformPrice" oninput="value = value.replace(/[^\d]/g,'')" clearable></el-input>
            </el-form-item>
            <el-form-item label="增加一次平台价格:" prop="stepPlatformPrice">
              <el-input v-model="addSKU.stepPlatformPrice" oninput="value = value.replace(/[^\d]/g,'')" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-btn">
          <el-button @click="getNewSKU" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    查看主题-->
      <div class="dialog-cn theme-cn" v-if="isType === 'checkTheme'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="theme-from dialog-v">
          <div class="theme-ipt">
            <span>{{ submitType }}:</span>
            <div>
              <div>
                <el-select placeholder="请选择主题" v-model="theme" @change="changeTelescopic" clearable>
                  <el-option :label="item.titleName" :value="item.id" v-for="(item) in sampleTheme" :key="item.id"></el-option>
                </el-select>
                <el-button round @click="addTheme()">添加</el-button>
              </div>
              <el-table :data="technologyList" border style="width: 340px" :row-class-name="rowClassName">
                <el-table-column prop="titleName" label="主题"></el-table-column>
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <span slot="reference" class="color-blue" @click="deleteTheme(scope.row.index)">{{ scope.row.operation }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="getTheme" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    添加属性值-->
      <div class="dialog-cn addAttr-cn" v-if="isType === 'addAttr'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="addattr-content dialog-v">
          <div>
            <span>当前属性名:</span>
            <div>{{ content }}</div>
          </div>
          <div>
            <span>属性值:</span>
            <el-input v-model="AddSkuAttr" placeholder="请输入" ref="addAttrRef" clearable></el-input>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="addAttr" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    添加分类-->
      <div class="dialog-cn category-cn" v-if="isType === 'addCategory'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="category-ipt dialog-v">
          <div>
            <span> {{ submitType }}：</span>
            <el-input v-model="content" placeholder="请输入" ref="inputRef" clearable></el-input>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="addCategory" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    添加分类 创建产品时-->
      <div class="dialog-cn category-cn" v-if="isType === 'addAttrSwitch'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="category-ipt dialog-v">
          <div>
            <span style="width: 100px">属性名：</span>
            <el-input v-model="content" placeholder="请输入" ref="switchInputRef" clearable></el-input>
          </div>
          <div style="margin: 20px 0">
            <span style="width: 100px">是否前端展示：</span>
            <el-switch v-model="switchList.switch" active-color="#1473E6" inactive-color="#8c8c8c">
            </el-switch>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="addAttrSwitch" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    收款校验-->
      <div class="dialog-cn verify-cn" v-if="isType === 'verify'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-v">
          <div class="verify-ipt">
            <span>收款金额:</span>
            <el-input v-model="remarkMes.message" ref="verifyRef" type="number" :min="0" @mousewheel.native.prevent clearable></el-input>
          </div>
          <div class="verify-ipt">
            <span>备注:</span>
            <el-input v-model="remarkMes.labelTitle" type="textarea" clearable></el-input>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="changeVerify" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    选择属性值-->
      <div class="dialog-cn select-cn" v-if="isType === 'selectAttr'" style="width: 400px">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="select-attr dialog-v">
          <div class="text">属性名:<span>{{ content }}</span></div>
          <div style="">
            <el-table :data="selectedAttrValue" border @selection-change="handleChange" ref="dataTable">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column label="属性值" prop="propVal">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="hide" round>取消</el-button>
          <el-button @click="selectOK" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    管理SKU-->
      <div class="dialog-cn setSKU-cn" v-if="isType === 'setSKU'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div style="padding: 30px 30px 0" class="setsku-table dialog-v">
          <el-table :data="technologyList" border ref="dataTable" :row-class-name="rowClassName">
            <el-table-column label="SKU名称" prop="skuName"></el-table-column>
            <el-table-column label="基础P数" prop="basePage">
            </el-table-column>
            <el-table-column label="最大P数" prop="maxPage">
            </el-table-column>
            <el-table-column label="一次增加P数" prop="stepLength">
            </el-table-column>
            <el-table-column label="基础P平台价格" prop="minPlatformPrice">
            </el-table-column>
            <el-table-column label="增加一次平台价格" prop="stepPlatformPrice">
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <span class="color-blue" @click="handleSKU('编辑', scope.row)">编辑</span><br>
                <span class="color-blue" @click="handleSKU('删除', scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dialog-btn">
          <el-button @click="setSKU" round type="primary">确定</el-button>
        </div>
      </div>
      <!--  直传尺寸设置  -->
      <div class="dialog-cn" v-if="isType === 'setSize'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="set-size dialog-v">
          <el-table :data="technologyList" :row-class-name="rowClassName" border>
            <el-table-column label="尺寸" prop="size">
              <template v-slot="scope">
                <el-input v-model="scope.row.size" :class="{ 'input-readonly': scope.row.isSelect }" :readonly="scope.row.isSelect" ref="sizeRef" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template v-slot="scope">
                <el-select v-model="scope.row.type" placeholder="请选择">
                  <el-option v-for="item in setSizeSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope"><span class="color-blue" @click="setSize(scope.row)">{{ scope.row.operation }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dialog-btn">
          <el-button @click="setSizeOk" round type="primary">确定</el-button>
        </div>
      </div>
      <!--选择属性-->
      <div class="dialog-cn" v-if="isType === 'selectAttrValue'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="set-size dialog-v">
          <!-- <el-button @click="onAddAttr" round style="margin-bottom: 20px;">添加属性</el-button> -->
          <el-table :data="attrValueList" :row-class-name="rowClassName" border @selection-change="handleSelectionChange" style="max-height: 300px;overflow-y: scroll">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column label="属性名" prop="propKey">
            </el-table-column>
          </el-table>
        </div>
        <div class="dialog-btn">
          <el-button @click="selectAttr" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    新建合成类型-->
      <div class="dialog-cn" v-if="isType === 'addComposeType'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-v compose-type" style="margin-top: 20px">
          <el-form :model="addComposeType" label-width="150px">
            <el-form-item label="合成类型：">
              <el-input v-model="addComposeType.typeName" ref="composeRef" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否算入基础P数：">
              <el-switch v-model="addComposeType.allowAsBasePage" :active-value="1" :inactive-value="0">
              </el-switch>
              <el-tooltip class="item" effect="light" content="启用后，此合成类型页面不计入基础P数" placement="right">
                <el-button style="border: none;min-width: 30px !important;"><i class="el-icon-question" style="font-size: 20px"></i></el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="是否允许增加P数：">
              <el-switch v-model="addComposeType.allowAddPage" :active-value="1" :inactive-value="0">
              </el-switch>
              <el-tooltip class="item" effect="light" content="启用后，此合成类型可以修改P数" placement="right">
                <el-button style="border: none;min-width: 30px !important;"><i class="el-icon-question" style="font-size: 20px"></i></el-button>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-btn">
          <el-button @click="hide" round class="cancel">取消</el-button>
          <el-button @click="getComposeType" round type="primary">确定</el-button>
        </div>
      </div>
      <!--      关联平台类型-->
      <div class="dialog-cn" v-if="isType === 'contactPlatformType'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-v">
          <el-select v-model="platformType" clearable>
            <el-option v-for="item in platformTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </div>
        <div class="dialog-btn">
          <el-button @click="contactPlatformTypeOK" round type="primary">确定</el-button>
        </div>
      </div>
      <!--      添加合成尺寸-->
      <div class="dialog-cn" v-if="isType === 'addComposeSize'" style="width: 750px;">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="dialog-v">
          <div>
            <div style="margin-bottom: 20px;">
              <span>合成尺寸:</span>
              <el-select v-model="composeType" placeholder="请选择" style="margin: 0 20px" @change="changeType" clearable>
                <el-option :label="item.typeName" :value="item.id" v-for="item in composeTypeList" :key="item.id"></el-option>
              </el-select>
              <el-button round type="primary" @click="addTable">添加</el-button>
            </div>
            <div v-if="technologyList.length > 0">
              <el-table :data="technologyList" border :row-class-name="rowClassName">
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="尺寸类型" prop="composeName">
                </el-table-column>
                <el-table-column label="规格" prop="">
                  <template v-slot="scope"> 宽度:{{ scope.row.sizeWidth }}mm 高度:{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型">
                  <template v-slot="scope"> {{ scope.row.bleed.bleedName }} </template>
                </el-table-column>
                <el-table-column label="出血" prop="">
                  <template v-slot="scope"> 上方:{{ scope.row.bleed.bleedTop }}mm 下方:{{ scope.row.bleed.bleedBottom }}mm 内侧:{{ scope.row.bleed.bleedIn }}mm 外侧:{{ scope.row.bleed.bleedOut }}mm
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <span class="color-blue" @click="deleteCompose(scope.row.index)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="confirmCompose" round type="primary">确定</el-button>
        </div>
      </div>
      <!--    展示型文案-->
      <div class="dialog-cn" v-if="isType === 'primary'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <h3 v-html="content" class="dialog-v"></h3>
        <div class="dialog-btn">
          <el-button @click="tipsOK" round type="primary">确定</el-button>
        </div>
      </div>
      <BaseDialog ref="basedialogRef" @addAttr="addAttrName" @selectComposeType="select"></BaseDialog>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import store from '@/store'
import BaseDialog from '@/components/Dialog/BaseDialog/index'
import { composeTypeList, dictListNoPaging, bleedDetail, skuAdd, sizeList, composeTypeDetail, dictQueryByPid, composeTypeUpdate, composeTypeAdd, composeTypeUsable, skuGroupAddDetail, skuGroupAdd, spuUpdate, sampleAdd, sampleList, spuDelete, dictAdd, propertyAdd } from '@/api/pms'
import {
  getMenuById, complaintGetById, userRemoveAdmin, userAddAdmin, storeApplyStore, storeAuditStore, storeUpdateStore,
  userUpdate, complaintsHandleComplaints, menuUpdate, menuAddMenu, storeTypeGetStoreTypeList
} from '@/api/crm'
import { nullPostAxios, nullGetAxios, nullPutAxios, nullDeleteAxios } from '@/api/null'
import { accountWarningLinePost, chargeGet } from '@/api/epay'
export default {
  name: 'combined-dialog',
  components: {
    BaseDialog
  },
  data () {
    return {
      rechargeInfo: {
        amount: '',
        qrcode: '',
        outOrderNo: '',
        tradeMethod: ''
      },
      lock: true,
      queryInfo: {
        pageNum: 1,
        pageSize: 20
      },
      isShow: false,
      title: '',
      content: '',
      remarkMes: {
        message: {
          fullName: ''
        },
        index: '',
        labelTitle: ''
      },
      deleteMes: {
        deleteList: [],
        deleteIndex: [],
        message: ''
      },
      customerMes: {
        message: '',
        password: 'dfdgg'
      },
      memberForm: {
        name: '',
        phone: ''
      },
      selectedAttrValue: [], // 查找属性值
      rules: {
        name: [{
          required: true,
          message: '请填写姓名',
          trigger: 'blur'
        }, {
          min: 0,
          max: 10,
          message: '不能超过10个字符'
        }],
        phone: [{
          required: true,
          message: '请填写手机号',
          trigger: 'blur'
        }, {
          validator: this.$FormRules.checkPhone,
          trigger: 'blur'
        }]
      },
      addSKU: {
        basePage: 0,
        maxPage: '',
        stepLength: '',
        minPlatformPrice: '',
        stepPlatformPrice: '',
        platformPrice: 0
      },
      activities: [{
        content: '支持使用图标',
        timestamp: '2018-04-12 20:46',
        size: 'large',
        type: 'primary',
        icon: 'el-icon-more'
      }, {
        content: '支持自定义颜色',
        timestamp: '2018-04-03 20:46'
        // color: '#0bbd87'
      }, {
        content: '支持自定义尺寸',
        timestamp: '2018-04-03 20:46'
        // size: 'large'
      }, {
        content: '默认样式的节点',
        timestamp: '2018-04-03 20:46'
      }],
      addSKURule: {
        basePage: [{
          required: true,
          message: '请填写基础P数',
          trigger: 'blur'
        }],
        maxPage: [{
          required: true,
          message: '请填写最大P数',
          trigger: 'blur'
        }],
        stepLength: [{
          required: true,
          message: '请填写一次增加P数',
          trigger: 'blur'
        }],
        minPlatformPrice: [{
          required: true,
          message: '请填写基础P数平台价格',
          trigger: 'blur'
        }],
        stepPlatformPrice: [{
          required: true,
          message: '请填写增加一次平台价格',
          trigger: 'blur'
        }]
      },
      theme: '',
      AddSkuAttr: '',
      technologyList: [],
      category: '',
      index: '',
      selectedList: [],
      submitType: '',
      newList: [],
      setSizeTemplate: {
        size: '',
        type: '',
        operation: '添加'
      },
      setSizeSelect: [{
        label: '封面',
        value: '封面'
      }, {
        label: '内页',
        value: '内页'
      }],
      switchList: {
        content: '',
        switch: false
      },
      attrValueList: [],
      // 主题列表
      sampleTheme: [],
      // 选中的主题
      selectedWorkName: {},
      menuInfo: {
        name: '',
        perms: '',
        pid: '',
        sorting: '',
        type: '',
        component: '',
        url: ''
      },
      addmenurules: {
        type: [{
          required: true,
          message: '请选择菜单类型'
        }],
        name: [{
          required: true,
          message: '请填写菜单名称'
        }]
      },
      addComposeType: {
        typeName: '',
        allowAsBasePage: 0,
        allowAddPage: 0
      },
      composeKeyword: '',
      allowPage: false,
      platformType: '',
      platformTypeList: [],
      composeType: '',
      composeTypeList: [],
      valId: ''
    }
  },
  created () {
  },
  computed: {
    basePage () {
      let total = 0
      this.technologyList.forEach((item) => {
        if (item.composeSizeType.allowAsBasePage === 1) {
          total += parseInt(item.pageNum)
        }
      })
      return total
    }
  },
  methods: {
    show (type, title, content, list, index, labeltitle) {
      if (type !== 'rechargeOnline') {
        this.getAttrList()
        this.getAllTheme()
      }
      // 类型
      this.isType = type
      // 标题
      this.title = title
      this.content = content
      this.technologyList = list
      // 弹框显示
      this.isShow = true
      // 内容
      this.remarkMes.message = content
      this.remarkMes.labelTitle = labeltitle
      this.deleteMes.message = content
      this.customerMes.message = content
      // 需要删除的数据所在数组
      this.deleteMes.deleteList = list
      this.deleteMes.deleteIndex = index
      // index
      this.remarkMes.index = index
      this.index = index
      this.selectedList = []
      this.submitType = index
      this.theme = ''
      if (type === 'checkTheme') {
        this.technologyList = JSON.parse(JSON.stringify(list))
      }
      if (type === 'setSize') {
        if (list.length !== 0) {
          this.technologyList = list
        } else if (list.length === 0) {
          this.technologyList = [{
            size: '',
            type: '',
            operation: '添加',
            isSelect: false
          }]
        }
      }
      if (type === 'selectAttr') {
        this.getSelectedAttrValue()
      }
      if (type === 'addComposeType') {
        if (title === '编辑合成类型') {
          this.addComposeType = {
            allowAddPage: labeltitle.allowAddPage,
            allowAsBasePage: labeltitle.allowAsBasePage,
            typeName: labeltitle.typeName
          }
        }
        if (title === '新建合成类型') {
          this.addComposeType = {
            allowAddPage: 0,
            allowAsBasePage: 0,
            typeName: ''
          }
        }
      }
      if (type === 'complain') {
        complaintGetById(content).then((res) => {
          if (res.data.success) {
            this.remarkMes.message = res.data.data.storeCode
            this.remarkMes.labelTitle = res.data.data.salesmanName
            this.category = res.data.data.content
          }
        })
      }
      if (type === 'addSKU') {
        this.addSKU = {
          basePage: 0,
          maxPage: '',
          stepLength: '',
          minPlatformPrice: '',
          stepPlatformPrice: ''
        }
        let _this = this
        let flag = false
        this.technologyList.forEach((item) => {
          _this.$set(item, 'pageNum', 1)
          _this.$set(item, 'composeSizeType', [])
          _this.getComposeSizeType(item.composeTypeId).then(res => {
            item.composeSizeType = res
            if (item.composeSizeType.allowAddPage === 1) {
              flag = true
            }
            if (flag) {
              this.allowPage = true
            }
          })
          _this.$forceUpdate()
        })
      }
      if (type === 'rechargeOnline') {
        this.rechargeInfo = content
        this.submitType = '在线充值'
        setTimeout(this.changeRemarkDialog, 1000)
      }
    },
    hide () {
      this.isShow = false
      if (this.isType === 'checkTheme') {
        this.technologyList = []
      }
    },
    // 获取合成尺寸类型信息
    async getComposeSizeType (id) {
      let post = () => {
        return new Promise(resolve => {
          composeTypeDetail(id).then((res) => {
            if (res.data.success) {
              resolve(res.data.data)
            }
          })
        })
      }
      let result = await post()
      return result
    },
    //  获取属性值
    getSelectedAttrValue () {
      dictQueryByPid(this.remarkMes.labelTitle).then((res) => {
        if (res.data.success) {
          this.selectedAttrValue = res.data.data
        }
      })
    },
    // 获取主题
    getAllTheme () {
      if (this.$hasPermission('pms:admin:theme:list')) {
        return
      }
      sampleList(this.queryInfo).then((res) => {
        if (res.data.success) {
          this.sampleTheme = res.data.data.records
        }
      })
    },
    async changeRemarkDialog () {
      if (this.submitType === '主题') {
        nullPostAxios(this.index, {
          id: '',
          titleName: this.remarkMes.message
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: '编辑成功',
              type: 'success'
            })
            this.$emit('changeRemark')
          } else {
          }
        })
      }
      if (this.submitType === '姓名') {
        nullPutAxios(this.index, {
          id: this.remarkMes.message.userId,
          fullName: this.remarkMes.message.fullName
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: '编辑成功',
              type: 'success'
            })
          } else {
          }
        })
      }
      if (this.submitType === '告急额度') {
        accountWarningLinePost({ value: this.remarkMes.message }).then(res => {
          if (res.data.success) {
            this.$message({
              message: '设置成功',
              type: 'success'
            })
            this.$emit('updateWarningLine')
          }
        })
      }
      if (this.submitType === '在线充值') {
        console.log(this.rechargeInfo)
        await chargeGet(this.rechargeInfo.orderId
          // tradeMethod: this.rechargeInfo.tradeMethod
        ).then(res => {
          if (res.data.success) {
            if (res.data.data.paymentStatus === 'PAID') {
              this.$notify({
                title: '成功',
                message: '充值成功',
                type: 'success'
              })
              this.hide()
              this.$router.push('/epay/vpayCharge')
            } else if (res.data.data.paymentStatus === 'UNPAID' && this.submitType === '在线充值') {
              this.$notify({
                title: '失败',
                message: '暂未充值，请扫码充值。',
                type: 'error'
              })
            }
            if (res.data.data.paymentStatus === 'UNPAID' && (this.submitType === undefined) && this.isShow) {
              setTimeout(this.changeRemarkDialog, 1000)
            }
          }
        })
      }
      // if(this.submitType === '')
      // this.$emit('changeRemark', this.remarkMes)
      if (this.submitType !== '在线充值') {
        this.hide()
      }
    },
    deleteItem () {
      // const len = this.deleteMes.deleteIndex.length
      // if (len > 1) {
      //   for (var i = this.deleteMes.deleteList.length - 1; i >= 0; i--) {
      //     if (this.deleteMes.deleteList[i].status === true) {
      //       this.deleteMes.deleteList.splice(i, 1)
      //     }
      //   }
      // } else {
      //   this.deleteMes.deleteList.splice(this.deleteMes.deleteIndex, 1)
      // }
      if (this.technologyList === 'deleteAdmin') {
        userRemoveAdmin(this.remarkMes.labelTitle).then(res => {
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$emit('delete')
          }
        })
      }
      if (typeof this.deleteMes.deleteIndex === 'number') {
        this.deleteMes.deleteList.splice(this.deleteMes.deleteIndex, 1)
        this.$emit('delete', this.deleteMes.deleteIndex)
      }
      if (this.isType === 'delete') {
        nullDeleteAxios(this.remarkMes.labelTitle).then((res) => {
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$emit('delete')
          }
        })
      }
      if (this.index === 'get') {
        nullGetAxios(this.submitType).then((res) => {
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$emit('delete')
          } else {
          }
        })
      }
      if (this.index === 'post') {
        nullPostAxios(this.submitType).then((res) => {
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$emit('delete')
          } else {
          }
        })
      }
      this.hide()
    },
    copyMes () {
      let clipboard = new Clipboard('.btn')
      clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        // 释放内存
        clipboard.destroy()
      })
    },
    //  添加成员
    addMember () {
      this.$refs.addMenberform.validate((valid) => {
        if (valid) {
          let _this = this
          userAddAdmin({
            fullName: this.memberForm.name,
            phone: this.memberForm.phone,
            roleId: this.submitType
          }).then((res) => {
            if (res.data.success) {
              _this.show('copy', '确认提示', '手机号:' + _this.$msg.filterBridal(res.data.data.userName) + '<br>密码:' + res.data.data.password)
              _this.$emit('addMember')
            } else {
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消订单
    cancelOrder () {
      this.hide()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    balancePay () {
      let balance = 3000
      if (this.submitType === 'balanceapply') {
        if (this.content > balance) {
          this.$refs.balanceapplyRef.innerHTML = '当前余额不足</br>是否充值？'
        }
      }
      if (this.submitType === 'balanceCheckFalse') {
        this.hide()
      }
      if (this.submitType === 'balanceCheckTrue') {
        this.hide()
      }
      // this.hide()
    },
    //  审核通过
    async checktruePlatform () {
      let _this = this
      if (this.submitType === 'applyPlatform') {
        const { data: res } = await storeApplyStore(this.technologyList)
        if (res.success) {
          _this.show('primary',
            '申请成功', '<span style="margin-right: 20px;font-size: 16px">平台号:' +
            res.data.code + '</span> 平台名称:' + res.data.name + '<br><span style="font-size: 14px;color: #999">请等待审核人员审核</span>', '', 'applyPlatform', 'applyPlatform')
        } else {
          _this.hide()
        }
      }
      if (this.submitType === 'checkTrue') {
        const { data: res } = await storeAuditStore(this.technologyList)
        if (res.success) {
          _this.show('primary', '审核成功', '审核平台成功，已将账号信息以短信形式发送<br/>平台号:' + res.data.code +
            '<br>平台名称:' + res.data.name + '<br>账号:' + _this.$msg.filterBridal(res.data.userName) + `${res.data.password === undefined ? '' : '<br>密码:' + res.data.password}`, '', 'checkTrue', 'checkTrue')
        } else {
          _this.hide()
        }
      }
      if (this.submitType === 'checkFalse') {
        storeAuditStore(this.technologyList).then((res) => {
          if (res.data.success) {
            _this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            })
            _this.$router.push('./platformmes')
          } else {
            _this.hide()
          }
        })
      }
      if (this.submitType === 'savePlatform') {
        storeUpdateStore(this.technologyList).then((res) => {
          if (res.data.success) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            })
            _this.$router.push('./platformmes')
          } else {
            this.hide()
          }
        })
      }
      if (this.submitType === 'changeuserinfo') {
        const { data: res } = await userUpdate(this.technologyList)
        if (res.success) {
          this.$message.success('保存成功')
          this.$router.push('./customerinfo')
        } else {
          _this.hide()
        }
      }
    },
    //  创建SKU
    getNewSKU () {
      this.$refs.addSKURef.validate((valid) => {
        if (valid) {
          this.hide()
          this.addSKU.basePage = this.basePage
          if (this.content === '') {
            skuAdd(this.addSKU).then(res => {
              this.$emit('addSKU', {
                list: this.addSKU,
                index: this.index
              })
            })
          } else {
            this.setSKU()
          }
        } else {
          return false
        }
      })
    },
    // 选中节点变化
    changeTelescopic (data) {
      this.selectedWorkName = {}
      this.selectedWorkName = this.sampleTheme.find((item) => { // 这里的sampleTheme就是上面遍历的数据源
        return item.id === data
        // 筛选出匹配数据，是对应数据的整个对象
      })
      // this.theme = data;
      // 这里的data 是整个选中的节点数据， 包括id ， name 以及其他
    },
    // 添加主题
    addTheme () {
      for (let i = 0; i < this.technologyList.length; i++) {
        if (this.technologyList[i].id === this.selectedWorkName.id) {
          this.$message.warning('该主题已存在')
          return false
        }
      }
      if (this.theme === '') {
        this.$message.warning('请先选择主题')
        return false
      }
      let newList = {
        titleName: this.selectedWorkName.titleName,
        operation: '删除',
        id: this.selectedWorkName.id
      }
      this.technologyList.push(newList)
      this.theme = ''
    },
    getTheme () {
      this.$emit('addTheme', {
        list: this.technologyList,
        index: this.remarkMes.labelTitle
      })
      this.hide()
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    deleteTheme (index) {
      const h = this.$createElement
      this.$msgbox({
        title: '确定提示',
        message: h('p', null, [
          h('p', { style: 'color: #666;font-size: 16px;' }, '删除确定'),
          h('p', { style: 'color: #999;font-size: 14px;' }, '是否确定删除')
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(action => {
        this.technologyList.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    //  添加属性值
    addAttr () {
      // let _this = this
      // let num = 0
      if (this.AddSkuAttr === '') {
        this.$message({
          message: '属性名不能为空',
          type: 'warning'
        })
        this.$refs.addAttrRef.focus()
        return false
      }
      dictAdd({
        isMallShow: this.submitType,
        pid: this.index,
        propKey: this.content,
        propUrl: '',
        propVal: this.AddSkuAttr
      }).then((res) => {
        if (res.data.success) {
          this.$message.success('添加属性成功')
          this.$emit('addAttr', [this.content, this.AddSkuAttr])
          this.hide()
        }
      })
      // this.AddSkuAttr = ''
    },
    addCategory () {
      if (this.content === '') {
        this.$message.warning(this.submitType + '不能为空')
        this.$refs.inputRef.focus()
        return
      }
      if (this.submitType === '样品价格') {
        var reg = /^[0-9]+.?[0-9]*$/
        if (!reg.test(this.content)) {
          this.$message.warning('请输入正确的样品价格')
          this.$refs.inputRef.focus()
          this.content = ''
          return false
        } else {
          this.$emit('addList', this.content)
        }
      }
      if (this.submitType === '属性名') {
        propertyAdd({ propertyName: this.content }).then((res) => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('addList')
          } else {
          }
        })
      }
      if (this.submitType === '样品主题') {
        if (this.content.length > 20) {
          this.$message.warning(this.submitType + '不能超过20个字符')
          this.$refs.inputRef.focus()
          return
        }
        sampleAdd({
          themeName: this.content
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('addList')
          } else {
          }
        })
      }
      this.hide()
    },
    addAttrSwitch () {
      if (this.content === '') {
        this.$message.warning('属性名不能为空')
        this.$refs.switchInputRef.focus()
        return
      }
      let list = {
        name: this.content,
        switch: this.switchList.switch
      }
      this.$emit('addAttr', list)
      this.hide()
    },
    handleSelectionChange (val) {
      this.selectedList = val
    },
    changeVerify () {
      if (this.remarkMes.message.length <= 0) {
        this.$message.warning('收款金额内容不能为空')
        this.$refs.verifyRef.focus()
        return
      }
      this.$emit('changeVerify', this.remarkMes)
      this.hide()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    onComplain () {
      if (this.category.length <= 0) {
        this.$message.warning('投诉内容不能为空')
        this.$refs.cmRef.focus()
        return
      }
      complaintsHandleComplaints({ id: this.content, handleStatus: 'HANDLE' }).then((res) => {
        if (res.data.success) {
          this.$message.success('已处理')
          this.$emit('asd')
        }
      })
      this.$emit('changeComplain', {
        index: this.index,
        mes: this.category
      })
      this.hide()
    },
    handleChange (val) {
      this.selectedList = val
    },
    selectOK () {
      this.$emit('select-attr', {
        isMallShow: this.technologyList,
        index: this.index,
        list: this.selectedList
      })
      this.hide()
    },
    tipsOK () {
      if (this.submitType === 'applyPlatform' || this.submitType === 'checkTrue') {
        this.$router.push('./platformmes')
      }
      if (this.submitType === 'productUpdate') {
        spuUpdate({ spuId: this.remarkMes.labelTitle, spuVO: this.technologyList }).then(res => {
        })
        this.$router.push({
          path: '/productlist'
        })
      }
      this.hide()
    },
    confirmOK () {
      let flag = true
      if ((typeof this.submitType) === 'object') {
        for (let i = 0; i < this.technologyList.length; i++) {
          let item = this.technologyList[i]
          if (item.skuGroupName === '' || item.imgInfo.src === '') {
            flag = false
            this.content = '您有未设置的SKU组信息<br/>请设置后创建'
            this.isType = 'primary'
          }
        }
        if (flag) {
          skuGroupAdd(this.index).then((res) => {
            if (res.data.success) {
              this.$router.push({
                path: './createnewsku2',
                query: {
                  list: JSON.stringify(res.data.data),
                  // list: JSON.stringify(this.technologyList),
                  tableColumns: JSON.stringify(this.remarkMes.labelTitle)
                }
              })
            }
          })
        }
      } else if (this.submitType === '创建sku组2') {
        for (let i = 0; i < this.technologyList.length; i++) {
          let item = this.technologyList[i]
          if (item.skuGroupName === '' || item.platformTypeId === '' || item.samplePrice === '' ||
            item.themeList.length === 0 || item.skus.length === 0 || item.composeSizeSet.length === 0) {
            flag = false
            this.content = '您有未设置的SKU组信息<br/>请设置后创建'
            this.isType = 'primary'
          }
        }
        if (flag) {
          skuGroupAddDetail(this.remarkMes.labelTitle).then((res) => {
            if (res.data.success) {
              this.$router.push('./productlist')
            }
          })
        }
      } else {
        this.hide()
      }
    },
    setSize (list) {
      list.isSelect = true
      if (list.size === '') {
        this.$message.warning('尺寸不能为空')
        this.$refs.sizeRef.focus()
        return false
      }
      if (list.type === '') {
        this.$message.warning('请选择类型')
        return false
      }
      if (list.operation === '添加') {
        this.technologyList.push(list)
        let newList = {
          size: '',
          type: '',
          operation: '添加',
          isSelect: false
        }
        this.$set(this.technologyList, this.technologyList.length - 1, newList)
        this.technologyList[list.index].isSelect = true
        let _this = this
        setTimeout(function () {
          _this.technologyList[list.index].operation = '删除'
        }, 100)
      }
      if (list.operation === '删除') {
        // this.technologyList.splice(list.index, 1)
        const h = this.$createElement
        this.$msgbox({
          title: '确定提示',
          message: h('p', null, [
            h('p', { style: 'color: #666;font-size: 16px;' }, '删除确定'),
            h('p', { style: 'color: #999;font-size: 14px;' }, '是否确定删除')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(action => {
          this.technologyList.splice(list.index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        // this.$confirm('删除确定,是否确定删除', '确定提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消'
        // }).then(() => {
        //   this.technologyList.splice(list.index, 1)
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功!'
        //   })
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        //   })
        // })
      }
    },
    setSizeOk () {
      this.$emit('addSize', {
        index: this.index,
        list: this.technologyList
      })
      this.technologyList = [{
        size: '',
        type: '',
        operation: '添加',
        isSelect: false
      }]
      this.hide()
    },
    handleSKU (val, row) {
      if (val === '删除') {
        const h = this.$createElement
        this.$msgbox({
          title: '确定提示',
          message: h('p', null, [
            h('p', { style: 'color: #666;font-size: 16px;' }, '删除确定'),
            h('p', { style: 'color: #999;font-size: 14px;' }, '是否确定删除')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(action => {
          this.technologyList.splice(val.index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }
      if (val === '编辑') {
        this.isType = 'addSKU'
        this.content = row.index
        this.technologyList = this.submitType
        this.$forceUpdate()
        // this.hide()
      }
    },
    setSKU () {
      this.$emit('setSKU', {
        list: this.addSKU,
        index: this.index,
        skuIndex: this.content
      })
      this.hide()
    },
    // 获取产品属性
    getAttrList () {
      if (this.$hasPermission('pms:admin:dict:list')) {
        return
      }
      dictListNoPaging(-1).then((res) => {
        this.attrValueList = res.data.data
        // this.attrValueList.forEach((item) => {
        //   if (item.isMallShow === 0) {
        //     item.isMallShow = '否'
        //   }
        //   if (item.isMallShow === 1) {
        //     item.isMallShow = '是'
        //   }
        // })
      })
    },
    onAddAttr () {
      this.$refs.basedialogRef.show('addAttrSwitch', '添加属性')
    },
    addAttrName () {
      this.getAttrList()
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    selectAttr () {
      this.$emit('selectAttr', this.selectedList)
      this.hide()
    },
    getComposeType () {
      if (this.title === '新建合成类型') {
        composeTypeUsable({
          act: 0,
          cutName: this.addComposeType.typeName
        }).then((res) => {
          if (res.data.success) {
            composeTypeAdd(this.addComposeType).then((res) => {
              if (res.data.success) {
                this.$message.success('添加合成类型成功')
                this.$emit('addComposeType')
                this.hide()
              } else {
                this.$refs.composeRef.focus()
                // this.$message.warning(res.data.message[0])
              }
            })
          } else {
            this.$message.warning('合成类型已存在')
          }
        })
      }
      if (this.title === '编辑合成类型') {
        composeTypeUsable({
          act: 1,
          sizeId: this.submitType,
          cutName: this.addComposeType.typeName
        }).then((res) => {
          if (res.data.success) {
            composeTypeUpdate({ typeId: this.submitType.id, composeTypeVo: this.addComposeType }).then((res) => {
              if (res.data.success) {
                this.$message.success('编辑合成类型成功')
                this.$emit('addComposeType')
                this.hide()
              } else {
                this.$refs.composeRef.focus()
                // this.$message.warning(res.data.message[0])
              }
            })
          } else {
            this.$message.warning('合成类型已存在')
          }
        })
      }
    },
    getComposeTypeSize () {
      sizeList().then((res) => {
        if (res.data.success) {
          let newList = []
          res.data.data.forEach((item) => {
            if (item.composeTypeId === parseInt(this.content)) {
              newList.push(item)
              newList.forEach((item2) => {
                item2.bleed = {
                  bleedName: '',
                  bleedOut: '',
                  bleedIn: '',
                  bleedTop: '',
                  bleedBottom: ''
                }
                this.getBleed(item2.bleedId).then(res => {
                  item2.bleed = res
                })
                item2.composeName = this.submitType
              })
            }
          })
          this.technologyList = newList
        } else {
        }
      })
    },
    async getBleed (id) {
      let post = () => {
        return new Promise(resolve => {
          bleedDetail(id).then((res) => {
            if (res.data.success) {
              resolve(res.data.data)
            }
          })
        })
      }
      let result = await post()
      return result
    },
    contactPlatformTypeOK () {
      if (this.platformType === '') {
        this.$message.warning('请选择平台类型')
        return false
      }
      this.$emit('addPlatformType', this.platformType)
      this.hide()
    },
    changeType (data) {
      this.selectedWorkName = this.composeTypeList.find((item) => { // 这里的sampleTheme就是上面遍历的数据源
        return item.id === data
        // 筛选出匹配数据，是对应数据的整个对象
      })
    },
    addTable () {
      if (this.composeType === '') {
        this.$message.warning('请选择合成尺寸类型')
        return false
      }
      this.$refs.basedialogRef.show('selectComposeSize', '选择尺寸', this.composeType, '', '', this.selectedWorkName.typeName)
      this.composeType = ''
    },
    select (val) {
      this.technologyList = val
    },
    deleteCompose (index) {
      this.technologyList.splice(index, 1)
    },
    confirmCompose () {
      if (this.technologyList.length !== 2) {
        this.$message.warning('请选择合成尺寸')
        return false
      }
      this.$emit('addComposeSize', {
        index: this.index,
        list: this.technologyList
      })
      this.hide()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";
@import "./styles";
</style>
